import PlisseCalcPlisse from '../components/calc/plisse/CalcPlisse.svelte';
import PlisseCalcSlimPro from '../components/calc/plisse/CalcSlimPro.svelte';
import PlisseCalcPlisse16 from '../components/calc/plisse/CalcPlisse16.svelte';
import PlisseCalcSmart from '../components/calc/plisse/CalcSmart.svelte';
import PlisseCalcPlugin from '../components/calc/plisse/CalcPlugin.svelte';
import PlisseCalcPlissePlugin from '../components/calc/plisse/CalcPlissePlugin.svelte';
import PlisseCalcCommon from '../components/calc/plisse/CalcCommon.svelte';
import PlisseCalcO2 from '../components/calc/plisse/CalcO2.svelte';
import CalcMounting from '../components/calc/CalcMounting.svelte';
import PartMaterials from '../components/parts/Materials.svelte';
import PartPrice from '../components/parts/Price.svelte';

let list = [];
let logo = null;
let precision = null;

if (APP_TYPE === 'axis-plisse') {
    logo = 'setkaplisse.png';
    precision = 1;

    list.push({
        title: 'Smart',
        calc: 'Smart',
        img: '/img/plisse/axis-plisse/smart.jpg,/img/plisse/axis-plisse/smart2.jpg,/img/plisse/axis-plisse/smart3.jpg,/img/plisse/axis-plisse/smart4.jpg,/img/plisse/axis-plisse/smart5.jpg',
        description: 'Плиссе для любых проемов. Профиль 40-27 мм. Ширина волны сетки 16-20 мм',
        link: 'smart',
        component: PlisseCalcSmart,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Неокрашенный': 'Неокрашенный',
            },
            uplotnenie: {
                'Без уплотнения': 'Без уплотнения',
            },
        }
    });

    list.push({
        title: 'SlimPro',
        calc: 'SlimPro',
        img: '/img/plisse/axis-plisse/slimpro.jpeg,/img/plisse/axis-plisse/slimpro2.jpg,/img/plisse/axis-plisse/slimpro3.jpg,/img/plisse/axis-plisse/slimpro4.jpg',
        description: 'Плиссе для средних размера проемов. Профиль: 25-25 мм. Ширина волны сетки: 14-16 мм. ТОЛЬКО ДЛЯ ОКОН',
        link: 'slimpro',
        component: PlisseCalcSlimPro,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],

        options: {
            porojek: {
                'Нет': 'Нет',
            },
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Неокрашенный': 'Неокрашенный',
            },
            max: {
                width: 2500,
                height: 3000
            },
            recomend: {
                width: 1600,
                height: 2000
            }
        }
    });

    list.push({
        title: 'Вставная сетка плиссе',
        calc: 'Вставная Плиссе',
        img: '/img/plisse/pluginplisse.mp4',
        description: 'Легкая и быстрая установка сетки плиссе',
        link: 'вставная-плиссе',
        component: PlisseCalcPlissePlugin,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
            },

        }
    });

    list.push({
        title: 'Вставная сетка',
        calc: 'Вставная',
        img: '/img/plisse/plugin.jpg',
        description: 'Легкая и быстрая установка подходит для оконного фильтра',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            PartMaterials,

        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Неокрашенный': 'Неокрашенный',
            },
            uplot: {
                'Шнур фиксирующий': 'Шнур',
            },
            polotno: {
                'Наносетка': 'Наносетка',
                'Сетка москитная, PPE': 'PPE',
                'Сетка москитная, АнтиМОШКА': 'АнтиМОШКА',
                'Сетка москитная, антикошка белое': 'Антикошка белое',
                'Сетка москитная, антикошка черное': 'Антикошка черное',
                'Сетка москитная, стандарт': 'Стандарт',
                'Оконный фильтр Оберег': 'Оконный фильтр Оберег'
            }

        }
    });

    list.push({
        title: 'Рамочная сетка',
        calc: 'Обычная',
        img: '/img/plisse/common.jpg',
        description: 'Рамочная москитная сетка на кронштейнах или крючках',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            PartMaterials,

        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит(RAL7016) мат.': 'Антрацит(RAL7016) мат.',
                'Неокрашенный': 'Неокрашенный',
            },
            polotno: {
                'Наносетка': 'Наносетка',
                'Сетка москитная, PPE': 'PPE',
                'Сетка москитная, АнтиМОШКА': 'АнтиМОШКА',
                'Сетка москитная, антикошка белое': 'Антикошка белое',
                'Сетка москитная, антикошка черное': 'Антикошка черное',
                'Сетка москитная, стандарт': 'Стандарт',
                'Оконный фильтр Оберег': 'Оконный фильтр Оберег'
            }
        }
    });

    list.push({
        title: 'Защита нового поколения О2',
        calc: 'Детская',
        img: '/img/plisse/o2.jpeg',
        description: 'Прозрачные решетки (ламели) защитят от выпадения ребенка',
        link: 'защита-о2',
        component: PlisseCalcO2,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            polotno: {
                'Наносетка': 'Наносетка',
                'Сетка москитная, PPE': 'PPE',
                'Сетка москитная, АнтиМОШКА': 'АнтиМОШКА',
                'Сетка москитная, антикошка белое': 'Антикошка белое',
                'Сетка москитная, антикошка черное': 'Антикошка черное',
                'Сетка москитная, стандарт': 'Стандарт',
                'Оконный фильтр Оберег': 'Оконный фильтр Оберег'
            }
        }
    });

    list.push({
        title: 'Плиссе',
        calc: 'Плиссе',
        img: '/img/plisse/axis-plisse/plisse.jpg,/img/plisse/axis-plisse/plisse2.jpg,/img/plisse/axis-plisse/plisse3.jpg,/img/plisse/axis-plisse/plisse4.jpg,/img/plisse/axis-plisse/plisse5.jpg,/img/plisse/axis-plisse/plisse6.jpg,/img/plisse/axis-plisse/plisse7.jpg,/img/plisse/axis-plisse/plisse8.jpg',
        description: 'Плиссированная сетка со складками шириной 25мм. Профиль: 40-30 мм. Максимальные размеры ширина 6 м. и высота 3м.',
        link: 'плиссе',
        component: PlisseCalcPlisse,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            porojek: {
                'Нет': 'Рамный(40мм)',
                '225мм': 'Двухсторонний(20мм)',
                '125мм': 'Односторонний(20мм)',
            },
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Неокрашенный': 'Неокрашенный',
            }
        }
    })

    list.push({
        title: 'Плиссе 16мм',
        calc: 'Плиссе 16мм',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Сетка плиссе со складками шириной 16мм. Максимальные размеры ширина 1.6м. и высота 2.2м',
        link: 'плиссе-16',
        component: PlisseCalcPlisse16,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Неокрашенный': 'Неокрашенный',
            }
        }
    });

}

export {list, logo, precision};
